<template>
  <div class="certificate-info">
    <div v-if="overData.answerCertificate.effType === 1">
      <Certificate ref="certificate" :overData="overData" :shortUrl="survey.shortUrl" :survey="survey"/>
      <el-button type="primary" class="w-full" @click="downloadCertificate">下载证书</el-button>
    </div>
    <div v-else-if="overData.answerCertificate.effType === 2">
      <div v-html="overData.answerCertificate.scoreOutsideTips.richText"></div>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'
const Certificate = () => import('components/certificate/Certificate')

export default {
  name: 'CertificateInfo',
  components: { Certificate },
  props: {
    overData: {
      type: Object,
      default: {}
    },
    survey: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {}
  },
  methods: {
    downloadCertificate() {
      if(this.$refs.certificate.blob === null) {
        this.$message.error('证书下载错误，请刷新页面重试')
        return
      }
      saveAs(this.$refs.certificate.blob, `合格证书.png`)
    }
  },
  created() {
    if(this.overData.answerCertificate.effType === 2) {
      this.overData.answerCertificate.scoreOutsideTips.richText = (this.overData.answerCertificate.scoreOutsideTips.richText || '').replaceAll('[Score]', this.overData.score)
    }
  }
}
</script>

<style scoped lang="scss"></style>
